<template>
  <div class="p-24">
    <h2 class="heading-1">{{ i18n(translations.mainTitle) }}</h2>
    <div class="text-static-default-low body-2 mt-8">
      {{ i18n(translations.description) }}
    </div>
    <RevDivider class="my-24" />
    <ContentRow
      class="mt-24"
      :labels="[i18n(translations.item1Description)]"
      :title="i18n(translations.item1Title)"
    >
      <IconClock />
    </ContentRow>
    <ContentRow
      class="mt-24"
      :labels="[i18n(translations.item2Description)]"
      :title="i18n(translations.item2Title)"
    >
      <IconBattery />
    </ContentRow>
    <ContentRow
      class="mt-24"
      :labels="[i18n(translations.item3Description)]"
      :title="i18n(translations.item3Title)"
    >
      <IconListViewChecks />
    </ContentRow>
  </div>
</template>

<script lang="ts" setup>
import ContentRow from '@backmarket/nuxt-layer-product-modals/ContentRow.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDivider } from '@ds/components/Divider'
import { IconBattery } from '@ds/icons/IconBattery'
import { IconClock } from '@ds/icons/IconClock'
import { IconListViewChecks } from '@ds/icons/IconListViewChecks'

import translations from './ItemObsoleteSoftwareModalBody.translations'

const i18n = useI18n()
</script>
